<div rvSpinner="screen-share-loader" [rvShowSpinner]="!availableDisplays || loadingDisplays()">
  @if (availableDisplays) {
    @if (!userStateService.isModerator()) {
      <div class="moderator-notice aligner flex-col">
        @if (userStateService.isUserAdmin()) {
          <img src="/images/screen-sharing/permissions.png" width="200" height="200" alt="User Permissions">
          <h4>Permission Needed</h4>
          <p class="align-center">
            Good news! You are an admin, and can give yourself permission to use Screen Share Moderation. Please go to User Settings and check the role “Screen Share Moderator”.
          </p>
          @if (!rvshareAppDetectionService.isScreenShareApp()) {
            <a mat-flat-button color="primary" class="my-4 px-4" uiSref="apps.user.details">See My User Settings</a>
          }
        }
        @else {
          <img src="/images/screen-sharing/padlock.png" width="200" height="200" alt="Permission Needed">
          <h4>Permission Needed</h4>
          <p class="">
            You don&rsquo;t have permission to use Screen Share Moderated Session. Please ask the admin to assign you the role of “Screen Share Moderator.”
          </p>
        }
      </div>
    }
    @else {
      <div class="moderator-join-layout">
        <div>
          @if (screenSharingService.channelError) {
            <div class="madero-style alert alert-danger mb-3">
              <div class="flex flex-row align-start">
                <mat-icon aria-hidden="true" fontIcon="fa-times-circle" class="icon-left"></mat-icon>
                <p class="mb-0">
                  {{ screenSharingService.channelError }}
                </p>
              </div>
            </div>
          }
        </div>
        <div>
          <mat-tab-group class="borderless -small-labels">
            <mat-tab label="All displays">
              <div class="tw-pt-[24px]">
                <div class="tw-px-[24px]">
                  <search-filter
                    [filterConfig]="filterConfig"
                    [search]="search"
                    [doSearch]="loadDisplays"
                    [focus]="true"
                  />
                </div>
                <mat-divider class="light tw-mt-[16px]"></mat-divider>
                <folder-path class="tw-px-[16px]" [folderTree]="folderService.folderTree" [folderId]="currentFolderId" (folderClicked)="onFolderClicked($event)" rootName="Displays"></folder-path>
                <mat-divider class="light"></mat-divider>
                <table mat-table [dataSource]="datasource">
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                      <div>Display Name</div>
                    </th>
                    <td mat-cell *matCellDef="let display">
                      <div class="flex flex-row tw-gap-4">
                        @if (savingFavorite === display.id) {
                          <mat-spinner diameter="15" class="tw-mr-[5px]"></mat-spinner>
                        }
                        @else if (!display.isFolder) {
                          <mat-icon
                            class="tw-text-[2rem] tw-cursor-pointer"
                            [fontIcon]="isFavored(getDisplay(display.id)) ? 'fa-star' : 'fa-star-o'"
                            [class.rise-blue]="isFavored(getDisplay(display.id))"
                            [class.rise-gray]="!isFavored(getDisplay(display.id))"
                            (click)="$event.stopPropagation();toggleFavorite(display.id)"
                            [attr.aria-label]="isFavored(getDisplay(display.id)) ? 'Remove from Favorites' : 'Add to Favorites'"/>
                        }
                        @if (!display.isFolder && display.onlineStatus === 'online') {
                          <a class="tw-font-semibold tw-cursor-pointer" attr.aria-label="Start Session with {{ display.name }}" class="u_lh-1" uiSref="apps.screen-sharing.moderator-room" [uiParams]="{displayId: display.id, rvshare: rvshareAppDetectionService.isScreenShareApp()}">{{ display.name }}</a>
                        } @else {
                          <div class="tw-font-semibold tw-flex tw-flex-row tw-gap-4 tw-items-center">
                            @if (display.isFolder) {
                              <mat-icon svgIcon="folder"></mat-icon>
                            }
                            <span>{{ display.name }}</span>
                          </div>
                        }
                      </div>
                    </td>
                  </ng-container>
    
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef width="180">Status</th>
                    <td mat-cell *matCellDef="let display">
                      @if (!display.isFolder) {
                        <div class="tw-flex tw-flex-row tw-gap-8 tw-font-semibold">
                          <mat-chip class="badge tw-capitalize" [ngClass]="{ 'badge-green': display.onlineStatus === 'online' }">
                            {{ display.onlineStatus.replace('_', ' ') }}
                          </mat-chip>
                        </div>
                      }
                    </td>
                  </ng-container>
    
                  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                  <tr mat-row
                    [ngClass]="{ 'u_clickable': row.onlineStatus === 'online' || row.isFolder }"
                    *matRowDef="let row; columns: tableColumns"
                    (click)="row.isFolder && onFolderClicked(row.id)"
                    [uiSref]="row.onlineStatus === 'online' && 'apps.screen-sharing.moderator-room'"
                    [uiParams]="{displayId: row.id, rvshare: rvshareAppDetectionService.isScreenShareApp()}"
                  ></tr>
                </table>
                @if (availableDisplays.length === 0) {
                  <div class="aligner flex-col">
                    <img src="/images/screen-sharing/settings.png" width="200" height="200" alt="Display Settings" class="tw-mt-[5vh]">
                    <h4>No Displays with Moderator Mode</h4>
                    <div>
                      <p>
                        To enable Moderator Mode:
                      </p>
                      <ol>
                        <li>Go to <strong>Displays</strong> and select a display.</li>
                        <li>In the General tab, toggle <strong>License this display</strong>.</li>
                        <li>In the Screen Sharing tab, toggle <strong>Moderator Mode</strong>.</li>
                      </ol>
                    </div>
                    @if (!rvshareAppDetectionService.isScreenShareApp()) {
                      <a mat-flat-button color="primary" class="my-4 px-4" uiSref="apps.displays.list">See Displays</a>
                    } 
                  </div>
                }
              </div>
            </mat-tab>
            <mat-tab label="Favorites">
              <div class="tw-pt-[24px]">
                <div class="tw-px-[24px]">
                  <search-filter
                    [filterConfig]="favoriteFilterConfig"
                    [search]="search"
                    [localSearch]="true"
                    [doSearch]="searchFavorites"
                  />
                </div>
                <table mat-table [dataSource]="favoritesDataSource">
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                      <div>Display Name</div>
                    </th>
                    <td mat-cell *matCellDef="let display">
                      <div class="flex flex-row tw-gap-1">
                        @if (savingFavorite === display.id) {
                          <mat-spinner diameter="15" class="tw-mr-[5px]"></mat-spinner>
                        }
                        @else if (!display.isFolder) {
                          <mat-icon
                            class="tw-text-[2rem] tw-cursor-pointer"
                            [fontIcon]="isFavored(getDisplay(display.id)) ? 'fa-star' : 'fa-star-o'"
                            (click)="$event.stopPropagation();toggleFavorite(display.id)"
                            [attr.aria-label]="isFavored(getDisplay(display.id)) ? 'Remove from Favorites' : 'Add to Favorites'"
                            [class.rise-blue]="isFavored(getDisplay(display.id))"
                            [class.rise-gray]="!isFavored(getDisplay(display.id))" />
                        }
                        @if (!display.isFolder && display.onlineStatus === 'online') {
                          <a class="tw-font-semibold tw-cursor-pointer" attr.aria-label="Start Session with {{ display.name }}" class="u_lh-1" uiSref="apps.screen-sharing.moderator-room" [uiParams]="{displayId: display.id, rvshare: rvshareAppDetectionService.isScreenShareApp()}">{{ display.name }}</a>
                        } @else {
                          <div class="tw-font-semibold tw-flex tw-flex-row tw-gap-4 tw-items-center">
                            @if (display.isFolder) {
                              <mat-icon svgIcon="folder"></mat-icon>
                            }
                            <span>{{ display.name }}</span>
                          </div>
                        }
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef width="180">Status</th>
                    <td mat-cell *matCellDef="let display">
                      @if (!display.isFolder) {
                        <div class="tw-flex tw-flex-row tw-gap-8 tw-font-semibold">
                          <mat-chip class="badge tw-capitalize" [ngClass]="{ 'badge-green': display.onlineStatus === 'online' }">
                            {{ display.onlineStatus.replace('_', ' ') }}
                          </mat-chip>
                        </div>
                      }
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                  <tr mat-row
                    [ngClass]="{ 'u_clickable': row.onlineStatus === 'online' || row.isFolder }"
                    *matRowDef="let row; columns: tableColumns"
                    (click)="row.isFolder && onFolderClicked(row.id)"
                    [uiSref]="row.onlineStatus === 'online' && 'apps.screen-sharing.moderator-room'"
                    [uiParams]="{displayId: row.id, rvshare: rvshareAppDetectionService.isScreenShareApp()}"
                  ></tr>
                </table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    }
  }
</div>
